// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import '../styles/landkit/index.js';
import '../images';
import '../channels';
import '../controllers';

require('@rails/ujs').start();
require('turbolinks').start();
require('@rails/activestorage').start();


import 'bootstrap/dist/js/bootstrap.js';

import 'aos/dist/aos.js';
import 'assets/libs/fotorama-4.6.4/fotorama.js';
import 'smooth-scroll/dist/smooth-scroll.min.js';
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-video.min.js';
import 'jarallax/dist/jarallax-element.min.js';
import 'typed.js/lib/typed.min.js';
import 'countup.js/dist/countUp.min.js';
import 'highlightjs/highlight.pack.min.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'jquery-bridget/jquery-bridget.js'
import 'isotope-layout/dist/isotope.pkgd.min.js';
import 'imagesloaded/imagesloaded.pkgd.min.js';

import '@fortawesome/fontawesome-free/css/all.css';


jQueryBridget( 'isotope', Isotope, $ );
jQueryBridget( 'flickity', Flickity, $);

const flatpickr = require('flatpickr');
const inputSpinner = require('bootstrap-input-spinner')
import 'assets/js/landkit/theme.min.js';
import '../landkit/js/customization.js';


// https://inopinatus.org/2019/09/14/webpacker-jquery-and-jquery-plugins/
